import { render, staticRenderFns } from "./PassCandidateDialog.vue?vue&type=template&id=28d8e630&scoped=true&"
import script from "./PassCandidateDialog.vue?vue&type=script&lang=ts&"
export * from "./PassCandidateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PassCandidateDialog.vue?vue&type=style&index=0&id=28d8e630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8e630",
  null
  
)

export default component.exports